import React from "react";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import { selectSelectedPumpOptionList } from "../../../../redux/selectors";

const SelectedPumps = () => {
    const selectedPumpOptionList = useSelector(selectSelectedPumpOptionList);

    const rowStyle = { backgroundColor: '#f9f9f9', padding: '10px' };
    const labelStyle = { fontWeight: 'bold' };

    return (
        <div>
            {selectedPumpOptionList.length > 0 ? (
                <Table striped bordered hover className="selected-pumps-responsive-table">
                    <tbody>
                        {selectedPumpOptionList.map((pumpOptionItem, index) => (
                            <React.Fragment key={index}>
                                <tr style={rowStyle} className="selected-pump-summary-row">
                                    <td><span style={labelStyle}>Option Number:</span> {pumpOptionItem.OptionNumber}</td>
                                    <td><span style={labelStyle}>Part Name:</span> {pumpOptionItem.PartName}</td>
                                    <td><span style={labelStyle}>Quantity:</span> {pumpOptionItem.Quantity}</td>
                                </tr>
                                <tr style={rowStyle} className="selected-pump-description-row">
                                    <td colSpan="3">
                                        <strong>Description:</strong>
                                        <div>{pumpOptionItem.Description}</div>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <div>No pump options available</div>
            )}
        </div>
    );
};

export default SelectedPumps;
